module.exports = __webpack_public_path__ + "img/kakas80.67aab67c.jpg";